// Global const
import {
  formLimitation,
  DEVICE_ATTR
} from "const";

// Local const
import {
  defaultProfile,
  defaultLinkSpeedOptionsDefinitions,
  defaultPortTypes
} from '../const';
import {
  ACCESS_POLICY_UNSUPPORTED_MODELS
} from 'pages/System/RealmSetting/components/Wired/const';

// Global utils
import {
  calcVlanIdsCountByDevice,
} from "utils/validate";

export const getProfileRequestParams = ({ auth }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/profilePorts.read`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];

  return {
    apiUrl,
    requestParams
  };
}

export const getInitProfileList = ({
  profileList,
  selectedPort
}) => {
  const filteredProfileList = [defaultProfile, ...profileList].filter(profile => profile.isDefault || profile.deviceCategory === selectedPort.deviceCategory)
  const initProfileList = filteredProfileList.map(profile => {

    return {
      ...structuredClone(profile),
      label: profile?.label ?? profile.name,
      value: profile.value ?? profile.name,
      isPortScheduleMode: !!profile.portSchedule,
      isPoeScheduleMode: !!profile.poeSchedule,
      isSelected: selectedPort?.portProfile ? selectedPort.portProfile === profile.id : !!profile.isDefault,
    }

  })

  return initProfileList;
}

export const getIsVlanInvalid = ({
  ports,
  selectedPort
}) => {
  let isVlanInvalid = false;
  const isSwitch = selectedPort?.deviceCategory === DEVICE_ATTR.types.SW.toLowerCase();
  const isAccessPoint = selectedPort?.deviceCategory === DEVICE_ATTR.types.AP.toLowerCase();

  const vlanIdsCount = calcVlanIdsCountByDevice(ports, selectedPort);

  if (vlanIdsCount.number > 128) isVlanInvalid = true;
  if (isSwitch && selectedPort?.portType === defaultPortTypes.trunk.value) {
    if (!checkAllowVlansFormat(selectedPort?.allowVlan)) isVlanInvalid = true;
  } else if(isAccessPoint){
    if (!checkAllowVlansFormat(selectedPort?.allowVlan)) isVlanInvalid = true;
  }

  return {
    vlanIdsCount,
    isVlanInvalid
  };
};

export const checkAllowVlansFormat = (value) => {
  if (!value?.trim()) return false;

  const parts = value.split(",").map((s) => s.trim());
  const used = new Set();
  const { min, max } = formLimitation.vlanId;

  for (let part of parts) {
    if (part === "") return false;

    if (part.includes("-")) {
      const [startStr, endStr] = part.split("-").map(s => s.trim());
      const start = parseInt(startStr, 10);
      const end = parseInt(endStr, 10);

      if (
        isNaN(start) ||
        isNaN(end) ||
        start < min ||
        end > max ||
        start > end
      )
        return false;

      for (let i = start; i <= end; i++) {
        if (used.has(i)) return false;
        used.add(i);
      }
    } else {
      const num = parseInt(part, 10);
      if (isNaN(num) || num < min || num > max) return false;

      if (used.has(num)) return false;
      used.add(num);
    }
  }

  return true;
};

export const checkPvid = (value) => {
  let isValid = true;

  if (value === "") {
    isValid = false;
  }

  if (!/^\d+$/.test(value)) {
    isValid = false;
  }

  const intValue = Number(value);
  if (intValue < 1 || intValue > 4094) {
    isValid = false;
  }

  return isValid;
};

export const getInputStyles = ({
  theme,
  isInValid,
  isEdited,
  field,
}) => {

  return {
    width: "300px",
    "& .MuiOutlinedInput-root": {
      borderRadius: theme.shape.customBorderRadius[1],
      height: "31px",
      backgroundColor: theme.palette.primary.transparent,

      "& .MuiOutlinedInput-notchedOutline": {
        border: isInValid ?
          `1px solid ${theme.palette.primary.redPrimary}` :
          (
            isEdited[field] ?
              `4px solid ${theme.palette.primary.orange}` :
              `1px solid ${theme.palette.primary.borderGreyPrimary}`
          ),
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: isInValid ?
          `1px solid ${theme.palette.primary.redPrimary}` :
          (
            isEdited[field] ?
              `4px solid ${theme.palette.primary.orange}` :
              `1px solid ${theme.palette.primary.mainHover}`
          )
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: isInValid ?
          `1px solid ${theme.palette.primary.redPrimary}` :
          (
            isEdited[field] ?
              `4px solid ${theme.palette.primary.orange}` :
              `1px solid ${theme.palette.primary.main}`
          )
      },
    },
  }
};

export const getLinkspeedList = ({
  speedList,
}) => {
  const labeledSpeedList = speedList
    .map(speed => defaultLinkSpeedOptionsDefinitions[speed])
    .sort((a, b) => a.id - b.id);

  return labeledSpeedList;
};

export const isAccessPolicyUnsupported = (modelOrSeriesName) => {
  if (!modelOrSeriesName) return false;
  return ACCESS_POLICY_UNSUPPORTED_MODELS.some((unsupported) =>
    modelOrSeriesName.startsWith(unsupported)
  );
};